import { LitElement, html } from 'lit';
import styles from './styles';
import AppContextConsumer from '../../../shared/context/app-context/AppContextConsumer';
import '../partners-registration-form/PartnersRegistrationForm';
import '../partners-registration-confirmation/PartnersRegistrationConfirmation';
import '../../../shared/components/step-wizard/StepWizard';

class PartnersRegistration extends LitElement {
  static styles = styles;

  static properties = {
    type: { type: String },
  };

  constructor() {
    super();
    this.type = 'partners';
  }

  context = AppContextConsumer(this);

  render() {
    const isOpenPartners = this.context.value?.type === 'openPartners';
    const title = isOpenPartners
      ? 'Tenable Open Partner Portal Registration'
      : 'Tenable Partner Portal Registration';

    return html`
      <div class="partners-registration-container w-50">
        <div class="panel panel-default registration-panel">
          <img src="${isOpenPartners ? 'https://static.tenable.com/partners/tenable_open_black.png' : 'https://static.tenable.com/partners/tenable-assure-logo.png'}" alt="Tenable">
          <div class="panel-heading">
            <h2>${title}</h2>
          </div>
          <tenable-step-wizard>
            <tenable-partners-registration-form type=${this.type}></tenable-partners-registration-form>
            <tenable-partners-registration-confirmation></tenable-partners-registration-confirmation>
          </tenable-step-wizard>
        </div>
      </div>
    `;
  }
}

customElements.define('tenable-partners-registration', PartnersRegistration);
